var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          class: _vm.isStagingEnv
            ? "draggable-view stage-bg"
            : "draggable-view",
          style: _vm.buttonStyle,
          on: { mousedown: _vm.startDrag }
        },
        [
          _c("i", { staticClass: "el-icon-rank" }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "button",
              on: {
                mousedown: function($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                },
                click: _vm.handleChangeGatewayEnv
              }
            },
            [
              _vm._v(
                "\n      切换" +
                  _vm._s(_vm.isStagingEnv ? "预发布" : "测试") +
                  "环境\n    "
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("EnvModal", {
        model: {
          value: _vm.isShowModalEnv,
          callback: function($$v) {
            _vm.isShowModalEnv = $$v
          },
          expression: "isShowModalEnv"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-06b1c3b1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06b1c3b1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FloatButton/index.vue
// module id = null
// module chunks = 